var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H18C18.8284 0.5 19.5 1.17157 19.5 2V15C19.5 15.8284 18.8284 16.5 18 16.5H2C1.17157 16.5 0.5 15.8284 0.5 15V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 4.91406C9.92127 4.91406 9.84325 4.92958 9.77045 4.95973C9.69766 4.98989 9.63151 5.03408 9.5758 5.0898C9.52008 5.14551 9.47589 5.21166 9.44573 5.28445C9.41558 5.35725 9.40006 5.43527 9.40006 5.51406V7.90506H7.01406C6.85493 7.90506 6.70232 7.96828 6.5898 8.0808C6.47728 8.19332 6.41406 8.34593 6.41406 8.50506C6.41406 8.66419 6.47728 8.81681 6.5898 8.92933C6.70232 9.04185 6.85493 9.10506 7.01406 9.10506H9.40506V11.4961C9.40506 11.6552 9.46828 11.8078 9.5808 11.9203C9.69332 12.0328 9.84593 12.0961 10.0051 12.0961C10.1642 12.0961 10.3168 12.0328 10.4293 11.9203C10.5418 11.8078 10.6051 11.6552 10.6051 11.4961V9.09806H12.9961C13.1552 9.09806 13.3078 9.03485 13.4203 8.92233C13.5328 8.80981 13.5961 8.65719 13.5961 8.49806C13.5961 8.33893 13.5328 8.18632 13.4203 8.0738C13.3078 7.96128 13.1552 7.89806 12.9961 7.89806H10.5981V5.51406C10.5981 5.43527 10.5825 5.35725 10.5524 5.28445C10.5222 5.21166 10.478 5.14551 10.4223 5.0898C10.3666 5.03408 10.3005 4.98989 10.2277 4.95973C10.1549 4.92958 10.0769 4.91406 9.99806 4.91406",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToolIcon);
export default __webpack_public_path__ + "static/media/add-tool-icon.c217cfe79d1dc8b57e721a990cde7214.svg";
export { ForwardRef as ReactComponent };